import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Icon } from '../../components';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

interface IProps {
    title?: string;
    subTitle?: string;
    showCloseButton?: boolean;
    goToPreviousStep: () => void;
}

export const WeightTargetHeader: FunctionComponent<IProps> = ({ title, subTitle, showCloseButton, goToPreviousStep }) => {
    return <View>
        <View style={styles.headingContainerStyle}>
        {showCloseButton ? (
            <TouchableOpacity
              onPress={goToPreviousStep}
              style={[styles.closeIconContainerStyle]}
            >
              <Icon
                name='md-close'
                color={Theme.GREY}
                size={defaultScale(30)}
              />
            </TouchableOpacity>
          ) : (
            <TouchableOpacity onPress={goToPreviousStep}>
              <Icon
                size={defaultScale(30)}
                color={Theme.GREY}
                name='ios-arrow-back'
                style={styles.iconStyle}
              />
            </TouchableOpacity>
          )}
            <Text style={styles.modalTitle}>{title}</Text>
            {subTitle && <Text style={styles.modalSubTitle}>{subTitle}</Text>}
        </View>
    </View>;
};

const styles = StyleSheet.create({
    modalTitle: {
        ...Theme.textStyle.heading,
        marginBottom: defaultScale(6),
        marginTop: defaultScale(15),
    },
    modalSubTitle: {
        ...Theme.textStyle.bodyCopyReg,
        color: Theme.GREY_MEDIUM,
        marginBottom: defaultScale(24),
    },
    headingContainerStyle: {
        paddingBottom: defaultScale(15),
    },
    iconStyle: {
        paddingTop: defaultScale(15),
    },
    closeIconContainerStyle: {
      alignSelf: 'flex-end',
      marginHorizontal: defaultScale(15),
      zIndex: 10,
      marginTop: defaultScale(15),
    },
});
